import { MutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { userKeys } from './user-keys';
import useGetUserAddress from 'src/hooks/useGetUserAddress';
import { Address } from 'viem';

export interface RequestWithdrawTradeResponse {
  publicKey: string;
  publicNonce: {
    kPublic: string;
    kTwoPublic: string;
  };
  signatureData: string;
  signatureID: number;
  usePreviousSignature: boolean;
}

export interface WithdrawReqDataTrade {
  tokenID: string;
  balance: number;
  chainID: number;
  publicNonce: {
    kPublic: string;
    kTwoPublic: string;
  };
  publicKey: string;
}

export const requestWithdrawTrade = async (data: WithdrawReqDataTrade) => {
  const response = await apiClient.post<RequestWithdrawTradeResponse>(
    '/api/v2/signatures/withdrawals',
    data,
    {
      baseURL: process.env.REACT_APP_SIGNATURE_SERVICE_API_ENDPOINT,
    },
  );
  console.log('response', response);
  return response.data;
};

export type UseRequestWithdrawTradeOptions<TError = Error, TContext = unknown> = MutationOptions<
  RequestWithdrawTradeResponse,
  TError,
  WithdrawReqDataTrade,
  TContext
>;

export const useRequestWithdrawTrade = <TError = Error, TContext = unknown>(
  options?: UseRequestWithdrawTradeOptions<TError, TContext>,
) => {
  const queryClient = useQueryClient();
  const { address: userAddress } = useGetUserAddress();
  return useMutation({
    mutationFn: requestWithdrawTrade,
    onSuccess() {
      return queryClient.invalidateQueries({ queryKey: userKeys.allBalances(userAddress as Address) });
    },
    ...options,
  });
};
